import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import globalMU from "globalMU"

declare var window:any

export type AlterarLinhaOrdemPedidoCompra = {
    identificadorItem: number,
    linhaOrdemPedidoCompra: string
}

export async function alterarOrdemPedidoCompraItem(input: AlterarLinhaOrdemPedidoCompra) {
    globalMU.blockUI()
    
    try {
        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarOrdemPedidoCompraCliente(
            input.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            input.linhaOrdemPedidoCompra
        )
    
        
        //const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)
        
        const orcamentoLegado = window.orcamentoController.model
        //const itensLegado = orcamentoLegado.get('ItensOrcamento')
        //const itemLegado = itensLegado.models.find(item => item.get('Identificador') == input.identificadorItem)
    
        //itemLegado.atualizar(itemAtualizado,true)
        orcamentoLegado.atualizar(orcamentoAtualizado)

        store.dispatch(atualizarItemAction({
            identificador: input.identificadorItem,
            dados: {UltimaInformacaoAtualizada: "LINHA_ORDEM_PEDIDO_COMPRA"}
        }))

    } finally {
        globalMU.unblockUI()
    }
    
}